var _defs, _path, _path2, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        stroke: #000;\n        stroke-miterlimit: 10;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        font-family: Roobert-Medium, Roobert;\n        font-size: 9px;\n        font-weight: 500;\n      }\n\n      .cls-4 {\n        letter-spacing: -.01em;\n      }\n\n      .cls-5 {\n        letter-spacing: 0em;\n      }\n\n      .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        letter-spacing: 0em;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m28.5,56.37c0,4.97,4.03,9,9,9s9-4.03,9-9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m17.66,56.37h39.68c2.3,0,3.75-2.22,2.61-4l-2.87-4.5c-.43-.67-.65-1.43-.65-2.21v-18.77c0-9.15-7.98-16.94-18.23-17.27-10.76-.34-19.61,7.34-19.61,16.86v19.17c0,.77-.23,1.53-.65,2.21l-2.87,4.5c-1.14,1.78.31,4,2.61,4Z"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(.05 -6.45)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 0,
    y: 0
  }, "N"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-4",
    x: 6.38,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.63,
    y: 0
  }, "tific"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 27.51,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    x: 32.35,
    y: 0
  }, "tion - "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 56.86,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.85,
    y: 0
  }, "n"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationOn);
export default __webpack_public_path__ + "static/media/__Notification - On.28e9675d410a7ad68f328b6d44d60f3f.svg";
export { ForwardRef as ReactComponent };